<template>
  <v-dialog :model-value="modelValue" max-width="560" persistent @update:model-value="close">
    <v-card v-if="modelValue">
      <v-card-title class="text-wrap">{{ $t(`${copyKey}.title`) }}</v-card-title>
      <v-card-text>
        <p class="mb-3">{{ $t(`${copyKey}.body`) }}</p>
        <ul class="ncrm-privacy-attestation__points mb-3">
          <li v-for="point in points" :key="point">{{ $t(`${copyKey}.${point}`) }}</li>
        </ul>
        <v-checkbox v-model="accepted" color="primary" hide-details density="compact" :label="$t(`${copyKey}.checkbox`)" />
        <v-alert v-if="error" type="error" density="compact" class="mt-3">{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="saving" @click="close">{{ $t(`${copyKey}.cancel`) }}</v-btn>
        <v-btn color="primary" variant="flat" :disabled="!accepted" :loading="saving" @click="$emit('confirm')">
          {{ $t(`${copyKey}.enable`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// GDPR S6.4a (`GDPR-099`) — declarația companiei la activarea invitațiilor către contactele fără
// acord. Serverul refuză activarea fără ea (`privacy_invitation_attestation_required`); dialogul
// doar o face explicită. La eroare rămâne deschis cu mesajul (`docs/design.md`).
export default {
  name: "NcrmPrivacyInvitationAttestationDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue", "confirm"],
  data: () => ({ accepted: false }),
  computed: {
    copyKey() { return "ncrm.contacts.dataProtection.workspace.purposes.settings.attestation"; },
    points() { return ["basis", "limits", "texts"]; },
  },
  watch: {
    modelValue(open) { if (open) this.accepted = false; },
  },
  methods: {
    close() { if (!this.saving) this.$emit("update:modelValue", false); },
  },
};
</script>

<style scoped>
.ncrm-privacy-attestation__points { padding-left: 20px; }
.ncrm-privacy-attestation__points li { margin-bottom: 6px; }
</style>
